import { formatMetricKey } from './semantics';
import type { FinancialMetrics } from './types';

interface MetricsGridProps {
  metrics: FinancialMetrics;
}

// Patterns that indicate the backend had no real data to report
const EMPTY_PATTERNS = [
  /not\s+explicitly\s+mention/i,
  /not\s+mention/i,
  /not\s+available/i,
  /not\s+applicable/i,
  /no\s+specific/i,
  /no\s+guidance/i,
  /n\/a/i,
  /^-+$/,
  /^null$/i,
  /^none$/i,
];

function isMeaningful(value: string): boolean {
  const v = value.trim();
  if (!v) return false;
  return !EMPTY_PATTERNS.some((re) => re.test(v));
}

export function MetricsGrid({ metrics }: MetricsGridProps) {
  const entries = Object.entries(metrics).filter(([, v]) => isMeaningful(v));
  if (!entries.length) return null;

  return (
    <div>
      <h3 className="text-xs font-bold uppercase tracking-widest text-neutral-400 mb-3">
        Financial Metrics
      </h3>
      <dl className="grid grid-flow-col auto-cols-fr gap-3">
        {entries.map(([key, value]) => (
          <div
            key={key}
            className="rounded-xl border border-neutral-200 bg-white p-4 hover:shadow-sm transition-shadow"
          >
            <dt className="text-[11px] font-semibold text-neutral-400 uppercase tracking-wide mb-1 truncate">
              {formatMetricKey(key)}
            </dt>
            <dd className="text-base font-bold text-neutral-900 leading-snug break-words">
              {value}
            </dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
